import { Injectable } from '@angular/core';
import { ZoneLayerAPIService } from '../API/ZoneLayersAPI.service';
import { UnileverAPIService } from '../API/UnileverAPI.service';
import { TerritoriesFiltersSelected } from 'src/app/features/map-features/sections/territories-section/Models/TerritoriesFilters';
import { TerritoriesListItem, TerritoryDTO } from 'src/app/features/map-features/sections/territories-section/Models/TerritoriesListItem';
@Injectable({
    providedIn: 'root'
  })


export class UnileverService{

  constructor(
    private unileverAPIService: UnileverAPIService){}
  
  GetLocationsByAGEBbyZoneUI(zone: string){
    return this.unileverAPIService.GetLocationsByAGEBbyZoneUI(zone);
  }

  GetNearestRouteFrecuencyByCoordsUI(lat: string, lng: string){
    return this.unileverAPIService.GetNearestRouteFrecuencyByCoordsUI(lat, lng);
  }

  GetPlanningTerritoriesFiltered(selectedFilters: TerritoriesFiltersSelected){
    return this.unileverAPIService.GetPlanningTerritoriesFiltered(selectedFilters);
  }

  GetPlanningTerritoriesDetails(selectedTerritory: TerritoryDTO){
    return this.unileverAPIService.GetPlanningTerritoriesDetails(selectedTerritory);
  }

  PlanningTerritoriesGetFilters(){
    return this.unileverAPIService.PlanningTerritoriesGetFilters();
  }
}
